import { decode } from "../../config";
import { apiFetch } from "../../utils/api";

const API_BASE_URL = decode(window._env_?.API_BASE_URL);

export const allProductionsAction = () => async (dispatch) => {
  try {
    const response = await fetch(`${API_BASE_URL}/Product/unauth_AllProducts`, {
      method: "GET",
    });

    if (response.status === 204) {
      dispatch({ type: "GET_PRODUCTS", payload: null });
      return null;
    }

    if (!response.ok) {
      throw new Error("Failed to fetch product details", response.text);
    }

    const data = await response.json();
    dispatch({ type: "GET_PRODUCTS", payload: data });
    return data;
  } catch (err) {
    console.error("Error loading product details:", err);
  }
};

export const productionDetailAction = (id) => async (dispatch) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Product/unauth_GetProductBYId`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: parseInt(id) }),
      }
    );
    if (response.status === 204) {
      dispatch({ type: "GET_DETAILS", payload: null });
      return null;
    }

    if (!response.ok) {
      throw new Error("Failed to fetch product details");
    }

    const data = await response.json();
    dispatch({ type: "GET_DETAILS", payload: data });
    return data;
  } catch (err) {
    console.error("Error loading product details:", err);
  }
};

export const allAvailableProductAction = () => async (dispatch) => {
  try {
    const res = await apiFetch(`${API_BASE_URL}/Product/AllAvailable`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });
    if (res.status === 204) {
      dispatch({ type: "GET_LISTS_PRODUCTS", payload: null });
      return null;
    }
    const data = await res.json();
    dispatch({ type: "GET_LISTS_PRODUCTS", payload: data });
  } catch (err) {
    console.error("Failed to fetch products:", err);
  }
};

export const allProductslistAction = () => async (dispatch) => {
  try {
    const res = await apiFetch(`${API_BASE_URL}/Product/AllProducts`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });
    if (res.status === 204) {
      dispatch({ type: "GET_ALL_LISTS_PRODUCTS", payload: null });
      return null;
    }
    const data = await res.json();
    dispatch({ type: "GET_ALL_LISTS_PRODUCTS", payload: data });
  } catch (err) {
    console.error("Failed to fetch products:", err);
  }
};

export const addNewProduct = (obj) => async (dispatch) => {
  try {
    const response = await apiFetch(`${API_BASE_URL}/Product/AddProduct`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj),
    });
    const data = await response.json();
    dispatch({ type: "ADD_PRODUCT", payload: data });
    return obj;
  } catch (err) {
    console.error("Error adding product details:", err);
  }
};
export const updateProduct = (obj) => async (dispatch) => {
  try {
    const response = await apiFetch(`${API_BASE_URL}/Product/UpdateProduct`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj),
    });
    const data = await response.json();
    dispatch({ type: "UPDATE_PRODUCT", payload: data });
  } catch (err) {
    console.error("Error updating product:", err);
  }
};

export const deleteProduct = (id) => async (dispatch) => {
  try {
    const response = await apiFetch(`${API_BASE_URL}/Product/DeleteProduct`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: parseInt(id) }),
    });
    if (!response.ok) {
      throw new Error("Failed to delete product details");
    }

    const data = await response.json();
    dispatch({ type: "DELETE_PRODUCT", payload: data });
    return data;
  } catch (err) {
    console.error("Error delete product details:", err);
  }
};
